module.exports = __webpack_public_path__ + "img/footer-bg-small.e4e1438d.png";